import BaseItemInterface from 'interfaces/base-item.interface';

interface ExtendedBaseItemInterface extends BaseItemInterface {
    isRanking?: boolean;
}

export const CUSTOM_TOP_DATA: ExtendedBaseItemInterface[] = [
    {
        url: '/kategoria/3319-telewizory.html',
        image: '',
        target: '_self',
        title: 'Telewizory'
    },
    {
        url: '/kategoria/17-laptopy.html',
        image: '',
        target: '_self',
        title: 'Laptopy'
    },
    {
        url: '/kategoria/200-telefony-komorkowe.html',
        image: '',
        target: '_self',
        title: 'Smartfony'
    }
];
